export default {
  'menu.IotHardwareNewPage': '新建设备',
  'menu.IotHardwareFormPage': '设备管理',

  'app.iotHardwarePage.attr.deviceStatus.enum.online': '在线',
  'app.iotHardwarePage.attr.deviceStatus.enum.offline': '离线',
}